import { createReducer, on } from '@ngrx/store';
import * as CatalogActions from './catalog.actions';
import { CatalogResponse } from '../../models/catalog.model';

export interface CatalogState {
  data: CatalogResponse | null;
  isLoading: boolean;
  error: string | null;
  lastLoadedCustomerId: string | null;
  lastLoadedCustomerName: string | null;
}

export const catalogInitialState: CatalogState = {
  data: null,
  isLoading: false,
  error: null,
  lastLoadedCustomerId: null,
  lastLoadedCustomerName: null,
};

export const catalogReducer = createReducer(
  catalogInitialState,
  on(CatalogActions.loadCatalog, (state) => ({ ...state, isLoading: true, error: null })),
  on(CatalogActions.loadCatalogSuccess, (state, { catalog, customerId, customerName }) => ({
    ...state,
    data: catalog,
    isLoading: false,
    lastLoadedCustomerId: customerId,
    lastLoadedCustomerName: customerName,
  })),
  on(CatalogActions.loadCatalogFailure, (state, { error }) => ({ ...state, error, isLoading: false })),
  on(CatalogActions.invalidateCatalog, () => catalogInitialState)
);
